import FileUploadContainer from "./FileUploadContainer";

export default FileUploadContainer;
